<div class="relative w-full max-w-md mx-auto">
  <!-- Efecto de pulso decorativo -->
  <div class="absolute -inset-0.5 bg-yellow-400 rounded-full blur opacity-30 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-pulse"></div>

  <!-- Contenedor de búsqueda con sombra y animación -->
  <div
    class="relative flex items-center w-full bg-white rounded-full shadow-lg border overflow-hidden transition-all duration-300 ease-in-out hover:shadow-xl group z-10"
    [ngClass]="{
      'border-yellow-400 shadow-xl': isActive,
      'border-gray-200': !isActive
    }"
    (click)="toggleActive($event)"
    >
    <!-- Icono de búsqueda con animación -->
    <div class="pl-3 sm:pl-4 pr-2 transition-all duration-300 group-hover:scale-110 group-hover:text-green-600">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-gray-500 group-hover:text-green-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>

      <!-- Input de búsqueda -->
      <input
        type="text"
        placeholder="Buscar dirección..."
        class="w-full py-3 px-2 text-gray-700 focus:outline-none text-sm transition-all duration-300 focus:font-medium"
        [(ngModel)]="searchText"
        (blur)="onBlur()"
        (keyup.enter)="search()"
        />

        <!-- Botón de búsqueda con animación -->
        <button
          class="px-4 py-2 bg-green-600 text-white rounded-r-full transition-all duration-300 transform hover:scale-105 hover:shadow-inner hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-50 flex items-center"
          (click)="search()"
          >
          <span class="hidden sm:inline-block mr-1 font-medium">Buscar</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 inline-block transition-transform duration-300"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </button>
        </div>

        <!-- Indicador de estado activo (opcional) -->
        <div
          class="mt-2 text-xs text-center text-green-600"
    [ngClass]="{
      'opacity-100': isActive && !searchText,
      'opacity-0': !isActive || searchText
    }"
          >
          <span class="font-medium">Escribe para buscar una dirección</span>
        </div>

        <!-- Indicador de carga -->
        @if (isLoading) {
          <div class="mt-2 flex justify-center">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-green-600"></div>
          </div>
        }

        <!-- Lista de resultados -->
        @if (showResults) {
          <div class="absolute z-20 mt-2 w-full bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
            <ul class="py-1">
              @for (place of searchResults; track place) {
                <li
                  class="px-4 py-2 hover:bg-green-50 cursor-pointer transition-colors duration-150 flex flex-col"
                  (click)="selectAddress(place)">
                  <span class="font-medium text-gray-800">{{ place.main_text }}</span>
                  <span class="text-xs text-gray-500">{{ place.secondary_text }}</span>
                </li>
              }
              @if (searchResults.length === 0 && !isLoading) {
                <li class="px-4 py-2 text-gray-500 text-center">
                  No se encontraron resultados
                </li>
              }
            </ul>
          </div>
        }
      </div>
